export const MAINTENANCE_MODE = 'pAAR2945PayexMaintenanceMode';
export const USE_PAYEX_PAYMENTS_CONTROLLER =
  'pAAR5316UsePayexPaymentsController';
export const CAMELIZED_FEATURES = [
  MAINTENANCE_MODE,
  USE_PAYEX_PAYMENTS_CONTROLLER,
] as const;
export const ENABLE_FEATURE = 'ENABLE_FEATURE';
export const FETCH_FEATURES_REQUEST = 'FETCH_FEATURES_REQUEST';
export const FETCH_FEATURES_SUCCESS = 'FETCH_FEATURES_SUCCESS';
export const FETCH_FEATURES_ERROR = 'FETCH_FEATURES_ERROR';
export const FF_HOLIDAY_BANNER_CN = 'PAAR-5353-holidayBannerCN';
export const FF_HOLIDAY_BANNER_VN = 'PAAR-5353-holidayBannerVN';
export const FF_CAPTCHA = 'PAAR-4218-VerifyTokenInBackend';
export const FF_USER_WALLET = 'PAAR-5247-userWallet';
export const FF_PAYING_FROM_INDIA_IN_USD = 'PAAR-5643-Mario';
export const FF_BANNER_COUPONS_CN = 'REM-1374-bannerCouponsCN';
export const FF_HIDE_KYC_BUTTON = 'PAAR-5826-hideKycButton';
export const FF_STUDENT_EXPENSES_PAYMENTS = 'REM-1383-StudentExpensesPayments';
export const FF_ACADEMIC_FIELDS = 'REM-1508-AcademicFields';
export const FF_PAY_INSTALLMENT = 'PAAR-6035-pay-installment';
export const FF_MANDATORY_ACCOUNT_INDIA = 'LOOP-1399-MandatoryAccountIndia';
export const FF_MANDATORY_ACCOUNT_INDIA_VERSION = 'LOOP-1399-MandatoryAccountIndiaVersion';

export const FEATURES = [
  'PAAR-2945-payex_maintenance_mode',
  'PAAR-5316_use_payex_payments_controller',
  FF_HOLIDAY_BANNER_CN,
  FF_HOLIDAY_BANNER_VN,
  FF_USER_WALLET,
  FF_PAYING_FROM_INDIA_IN_USD,
  FF_BANNER_COUPONS_CN,
  FF_HIDE_KYC_BUTTON,
  FF_STUDENT_EXPENSES_PAYMENTS,
  FF_ACADEMIC_FIELDS,
  FF_PAY_INSTALLMENT,
] as const;

const FEATURE_TYPES = [FF_CAPTCHA] as const;

const FEATURE_ABC_TEST = [
  FF_MANDATORY_ACCOUNT_INDIA,
  FF_MANDATORY_ACCOUNT_INDIA_VERSION,
] as const;

export type FeatureFlag =
  | (typeof FEATURES)[number]
  | (typeof FEATURE_TYPES)[number]
  | (typeof FEATURE_ABC_TEST)[number];
